<div class="title">{{ title }}</div>
<div class="subtitle" *ngIf="this.subtitle">{{ this.subtitle }}</div>

<mat-checkbox
  [disabled]="isDisabled"
  (change)="answered(checked)"
  [(ngModel)]="checked"
>
  <span [ngClass]="boldText ? 'strong' : ''">{{ text }}</span>
</mat-checkbox>
